export const environment = {
  production: false,
  apiUrl: 'https://api.dev.crm.cloheac.fr',
  // Les journaux, consultés depuis Administration > Journaux.
  seqUrl: 'https://seq.dev.crm.cloheac.fr',
  seqFilter: '',
};
